import type { FaireProductEntity } from "../../entity_types/product";

export const potluck_ssamjang_1: FaireProductEntity = {
  token: "potluck-ssamjang-1",
  type: "product",
  name: "Ssamjang Korean Barbeque Sauce",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c171978c55a1b25e5a677018a94d8113b4387f31e83c6ef062b5a136c29f7986.webp",
  priceDollars: 12,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  weight: 1.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 3,
  },
  description:
    "A savory Korean condiment that blends fermented soybean paste (doenjang) with gochujang, sesame oil, garlic, and other aromatics. Perfect for lettuce wraps, grilled meats, or as a dipping sauce.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["korean", "sauce", "condiment", "premium", "artisanal"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
